var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product&&_vm.product.id)?_c('div',{staticClass:"product-row-card"},_vm._l((_vm.showDatas),function(item){return _c('div',{key:item.code,staticClass:"product-row-card__column"},[_vm._v("\n   "+_vm._s(item.label)+"："),_c('span',{staticClass:"content"},[_vm._v(_vm._s(item.showContent))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }